import type { ReactElement } from 'react';
import React from 'react';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type IconProps = {
  icon: IconProp;
};

export default function Icon({ icon }: IconProps): ReactElement {
  switch (icon) {
    case 'check':
      return <FontAwesomeIcon icon={faCheck} color="green" />;
    case 'xmark':
      return <FontAwesomeIcon icon={faXmark} color="red" />;
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <></>;
  }
}
